import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  linkedCustomerList,
  linkedPharmacyList,
} from "../../../redux/actions/customerActions";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import TableCustomerData from "../TableCustomerData";
import NumberPagination from "../../../components/Pagination/number-pagination";
import ErrorPopup from "../../../components/popups/ErrorPopup";

const CustomerPharmacyTable = ({ search, page_no }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [linkedCustomerListData, setLinkedCustomerListData] = useState([]);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(linkedPharmacyList({ search, page }, onSuccess, onError));
  }, [page, search]);

  const onSuccess = (data) => {
    setLoading(false);
    setLinkedCustomerListData(data.data.data);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };
  return (
    <>
      <div>
        <div className="table-container text-nowrap">
          <table className="main-table" style={{ position: "relative" }}>
            <thead>
              <tr className="table-rows">
                <th className="table-heads " width={"3%"}>
                  #
                </th>
                <th className="table-heads" width={"10%"}>
                  Pharmacy Code
                </th>
                <th className="table-heads" width={"12%"}>
                  Pharmacy Name
                </th>
                <th className="table-heads" width={"12%"}>
                  Phone
                </th>
                <th className="table-heads" width={"8%"}>
                  Onboarding Type
                </th>
                <th className="table-heads" width={"8%"}>
                  Status
                </th>
                <th className="table-heads" width={"12%"}>
                  City
                </th>
                <th className="table-heads" width={"12%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading === true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : linkedCustomerListData?.data?.length > 0 ? (
                <>
                  {linkedCustomerListData?.data?.map((eachRow, index) => (
                    <TableCustomerData
                      key={eachRow.id}
                      data={eachRow}
                      index={index}
                      type={"pharmacy"}
                      currentPage={
                        linkedCustomerListData?.pagination?.currentPage
                      }
                    />
                  ))}
                </>
              ) : (
                <>
                  <tr>
                    <td
                      colSpan="1"
                      className="text-center no-data-container fs_16"
                    >
                      <span>~ No Data Found ~</span>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading === true ? `loading-event` : ""}>
          {linkedCustomerListData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={linkedCustomerListData?.pagination?.currentPage}
              totalPages={linkedCustomerListData?.pagination?.totalPages}
              path={"/customers/onboarded-pharmacy"}
              filters={`${queryString}`}
            />
          )}
        </div>
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default CustomerPharmacyTable;
